<template>
  <div>
    <navigation />
    <div class="audit-container">
      <el-table :data="toRepairTaskList" style="width: 100%">
        <el-table-column prop="id" label="任务ID" align="center"> </el-table-column>
        <el-table-column prop="createAt" label="创建时间" align="center" width="200"> </el-table-column>
        <el-table-column prop="imageCnt" label="图片数量" align="center"> </el-table-column>
        <el-table-column prop="unfinishedImageCnt" :formatter="reformatImageCnt" label="剩余数量" align="center">
        </el-table-column>
        <el-table-column
          v-if="roleId === 6"
          prop="reviewImageCnt"
          :formatter="reformatImageCnt"
          label="审核数量"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="reviewImageCnt" :formatter="calcModifiedImageRate" label="修改比例(%)" align="center">
        </el-table-column>
        <el-table-column label="备注" align="center">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" :content="scope.row.comment" placement="bottom">
              <span>{{ commentFormat(scope.row.comment) }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="status" :formatter="getModelTaskStatus" label="状态" align="center"> </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <div v-if="roleId === 6">
              <span
                v-if="scope.row.status === 1"
                style="color: #5d89c0;cursor: pointer;"
                @click="moveToModelAnno(scope.row)"
                >审核</span
              >
              <span v-else>
                -
              </span>
            </div>
            <div v-else>
              <span
                v-if="scope.row.status === 0"
                style="color: #5d89c0;cursor: pointer;"
                @click="updateModelTask(scope.row, 1)"
                >发布</span
              >
              <span
                v-if="scope.row.status !== 0"
                style="color: #5d89c0;cursor: pointer;"
                @click="getModelTaskStatistic(scope.row.id)"
                >统计</span
              >
              <span style="color: #5d89c0;cursor: pointer; margin-left: 10px" @click="updateModelTask(scope.row, 3)"
                >删除</span
              >
              <span style="color: #5d89c0;cursor: pointer; margin-left: 10px" @click="moveToModelAnno(scope.row)"
                >查看</span
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :page-size="pageSize"
        :page-index="pageIndex"
        :item-total="itemTotal"
        @changeindex="changePageIndex"
        @changesize="changePageSize"
      />
    </div>
    <el-dialog title="审核统计" :visible.sync="modelTaskStatisticVisible" width="40%" class="role-dialog">
      <el-table :data="userRevisionList">
        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column property="userName" label="审核员"></el-table-column>
        <el-table-column property="imageCnt" label="审核数量"></el-table-column>
        <el-table-column property="modifiedRate" label="修改比例(%)"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import navigation from '@/components/navigation';
import * as api from '@/api/api.js';
import pagination from '@/components/pagination';
import { roleMapReverse } from '@/config';
import Decimal from 'decimal.js';

export default {
  name: 'ModelAudit',
  components: {
    navigation,
    pagination,
  },
  data() {
    return {
      toRepairTaskList: [],
      pageSize: 20,
      pageIndex: 0,
      itemTotal: 0,
      roleId: 0,
      statusMap: {
        '0': '待发布',
        '1': '审核中',
        '2': '已完成',
        '3': '已删除',
      },
      modelTaskStatisticVisible: false,
      userRevisionList: [],
    };
  },
  computed: {
    commentFormat: function() {
      return function(comment) {
        comment = comment || '-';
        return comment.length > 15 ? comment.slice(0, 15).concat('...') : comment;
      };
    },
  },
  mounted() {
    this.roleId = roleMapReverse[this.$store.state.role];
    this.getTaskListToRepair();
  },
  methods: {
    getTaskListToRepair() {
      api.getTaskListToRepair({ p: this.pageIndex, ps: this.pageSize }).then(res => {
        this.toRepairTaskList = res.data.toRepairTaskList;
        this.itemTotal = res.data.totalAmount;
      });
    },
    moveToModelAnno(row) {
      this.$router.push({
        path: `/model/audit/${row.id}`,
      });
    },
    updateModelTask(row, status) {
      if (status === 3 && !window.confirm(`确认删除该模型审核任务吗`)) return;
      api.updateModelTask(row.id, { status }).then(() => {
        this.getTaskListToRepair();
      });
    },
    reformatImageCnt(row, column, cellValue) {
      return cellValue || 0;
    },
    calcModifiedImageRate(row) {
      if (this.roleId === 6) {
        return row.reviewImageCnt
          ? Decimal(row.modifiedImageCnt)
              .mul(100)
              .div(row.reviewImageCnt)
              .toNumber()
              .toFixed(0)
          : 0;
      } else if (this.roleId === 1) {
        return row.imageCnt === row.unfinishedImageCnt
          ? 0
          : Decimal(row.modifiedImageCnt || 0)
              .div(Decimal(row.imageCnt).sub(row.unfinishedImageCnt))
              .mul(100)
              .toNumber()
              .toFixed(0);
      }
    },
    getModelTaskStatus(row, column, cellValue) {
      return this.statusMap[cellValue];
    },
    getModelTaskStatistic(modelTaskId) {
      api
        .getModelTaskStatistic(modelTaskId)
        .then(res => {
          this.modelTaskStatisticVisible = true;
          const result = res.data;
          this.userRevisionList = Object.keys(result).map(v => {
            return {
              userId: v,
              userName: result[v].username,
              modifiedImageCnt: result[v].modified || 0,
              unmodifiedImageCnt: result[v].unmodified || 0,
              imageCnt: Decimal(result[v].modified || 0)
                .add(result[v].unmodified || 0)
                .toNumber(),
              modifiedRate: Decimal(result[v].modified || 0)
                .div(Decimal(result[v].modified || 0).add(result[v].unmodified || 0))
                .mul(100)
                .toNumber()
                .toFixed(0),
            };
          });
        })
        .catch(() => {});
    },
    changePageIndex(page) {
      this.pageIndex = page;
      this.getTaskListToRepair();
    },
    changePageSize(pageSize) {
      this.pageSize = pageSize;
      this.getTaskListToRepair();
    },
  },
};
</script>

<style scoped></style>
